import React, { Component } from 'react';
import {
  Paper,
  Grid,
  Typography,
} from '@material-ui/core';

import './Enroll.css';
import metadata from '../metadata';

export default class EnrollDescription extends Component {
  render() {
    return (
      <Paper className="paper-container">
      <Grid container alignItems="flex-start" spacing={8} >
        <Grid item xs={12}>
          <Typography variant="h4">{metadata.year} SCCCS Summer Camp Camper Application</Typography>
          <Typography variant="h4">青少年中華文化夏令營 </Typography>

          <ul>
            <li>
              Dates: {metadata.from} to {metadata.to} (8 days 7 nights)
            </li>
            <li>
              Location: {metadata.location}
            </li>
            <li>
              Online Application Deadline: {metadata.deadline} or earlier when at capacity  
            </li>
          </ul>

          <ul>
            <li>
              You may use iPad or PC for the online enrollment.
            </li>
            <li>
              You may enroll up to three children in the same household.
            </li>
          </ul>
        </Grid>
      </Grid>
      </Paper>);
  }
}
